import GrayCard from "components/gray-card";
import DateInput from "components/inputs/date-input";
import { addDays } from "utils/dateConvert";

interface IProps {
  date: Date | null;
  setDate: (date: Date | null) => void;
}
const ProposedDate = ({ date, setDate }: IProps) => {
  return (
    <GrayCard title="Proposed Release Date">
      <DateInput
        label="Release Date"
        selectDate={(date) => setDate(date)}
        initialDate={date}
        minDate={addDays(new Date(), 7)}
      />
    </GrayCard>
  );
};

export default ProposedDate;
